import { Injectable } from "@angular/core";
import { Store } from "@ngxs/store";
import * as AbsiTemplateVersionActions from './absi-template.action';
import { GeneralSignalRResponse } from "src/app/services/signal-r/general-signal-r-response";
import { SignalRService } from "src/app/services/signal-r/signal-r.service";
import { SignalRAction } from "src/app/services/signal-r/signalr-enums";
import { Channels } from "src/app/store/channels";

@Injectable({
  providedIn: 'root'
})
export class AbsiTemplateVersionStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new AbsiTemplateVersionActions.AbsiTemplateVersionRefresh(0));
  }

  initListeners() {
    // AbsiTemplateVersion
    this.signalRService.hubConnection?.on(Channels.ABSI_TEMPLATES, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new AbsiTemplateVersionActions.AbsiTemplateVersionCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new AbsiTemplateVersionActions.AbsiTemplateVersionUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new AbsiTemplateVersionActions.AbsiTemplateVersionDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new AbsiTemplateVersionActions.AbsiTemplateVersionRefresh(data.id));
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new AbsiTemplateVersionActions.AbsiTemplateVersionRefreshByID(data.id));

      }
    });

  }
}
